export const MOCK_LABEL_A_ID = 'MOCK_LABEL_A_ID'
export const MOCK_LABEL_B_ID = 'MOCK_LABEL_B_ID'
